var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-scrollbar',{class:_vm.isCollapse?'menu_hide rightSide':'rightSide'},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"load"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }